import React from 'react'

import Image from './image'
import Link from './link'
const Footer = (props) => {
  return (
    <div className="footer-static p-sm-3 pt-3">
      <div className="container-xxl position-relative">
        <div className="logo-symbol d-block d-sm-none d-lg-block">
          <Image src="logo-symbol.png" className="img-fluid" />
        </div>
        <div className="row">
          <div className="col-12 col-sm-4 order-sm-last mb-3">
            <div className="footer-title" role="heading" aria-level="3">Sign up and we'll spill the tea... aka our newsletter</div>
            <div className="subscribe-form p-2 my-3 border border-2 border-secondary">
              {/* <form action="https://cl.s11.exct.net/subscribe.aspx?lid=610" name="subscribeForm" method="post" onSubmit="return checkForm();"> */}
              <form onSubmit="javascript:sendData();">
                <input type="hidden" name="thx" value="https://www.omnidya.com" /> {/* Thank You Page Details here */}
                <input type="hidden" name="err" value="https://www.omnidya.com" /> {/* Error Page Details here */}
                <input type="hidden" name="MID" value="514010013" /> {/* Do not change this */}
                <div class="row">
                  <div class="col-lg-7 col-sm-12">
                    <input class="form-control border-0" id="num1" name="Email Address" type="text" placeholder="example@email.com" />
                  </div>
                  <div class="col-lg-5 col-sm-12 mt-xs-2">
                    <button type="submit" name="submit" class="btn btn-block btn-gradient">Yes</button>
                  </div>
                </div>
              </form>
            </div>
            <div className="footer-title" role="heading" aria-level="3">Follow us on everything: </div>
            <div className="socialMedia">
              <Link target="_blank" aria-label="Linkedin" to="https://www.linkedin.com/company/omnidya/?viewAsMember=true"><img alt="Linkedin" src="https://blog.omnidya.com/wp-content/uploads/2022/05/linkedin_icon.png" className="mt-2 mr-2" /></Link>
              <Link target="_blank" aria-label="Instagram" to="https://www.instagram.com/omnidya_ai/?hl=en"><img alt="Instagram" src="https://blog.omnidya.com/wp-content/uploads/2022/05/instagram_icon.png" className="mt-2 mr-2" /></Link>
              <Link target="_blank" aria-label="Facebook" to="https://m.facebook.com/Omnidya/"><img alt="Facebook" src="https://blog.omnidya.com/wp-content/uploads/2022/05/facebook_icon.png" className="mt-2 mr-2" /></Link>
              <Link target="_blank" aria-label="Magnum" to="https://medium.com/@Omnidya"><img alt="Magnum" src="https://blog.omnidya.com/wp-content/uploads/2022/05/magnum_icon.png" className="mt-2 mr-2" /></Link>
              <Link target="_blank" aria-label="Twitter" to="https://twitter.com/omnidya_ai?lang=en"><img alt="Twitter" src="https://blog.omnidya.com/wp-content/uploads/2022/06/twitter.png" className="mt-2" /></Link>
            </div>
            <div className="d-none d-sm-block d-lg-none wt-100 mx-auto mt-5">
              <Image src="logo-symbol.png" className="img-fluid" />
            </div>
          </div>
          <div className="col-12 col-sm-8 order-sm-first">
            <div className="row">
              <div className="col-6 col-sm-6 col-lg mb-3">
                <div className="footer-title" role="heading" aria-level="3">Omnidya</div>
                <ul className="footer-link">
                  <li>
                    <Link to="/about/" className="text-secondary">About</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy" className="text-secondary">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-conditions/" className="text-secondary">Terms & Conditions</Link>
                  </li>
                </ul>
              </div>
              <div className="col-6 col-sm-6 col-lg mb-3">
                <div className="footer-title" role="heading" aria-level="3">Availability</div>
                <ul className="footer-link">
                  {/* <li>
                    <Link to="#" className="text-secondary">Countries</Link>
                  </li>
                  <li>
                    <Link to="#" className="text-secondary">Options</Link>
                  </li> */}
                  <li>
                    <Link to="#" className="text-secondary">States</Link>
                    {/* <Link to="/availability/" className="text-secondary">States</Link> */}
                  </li>
                </ul>
              </div>
              <div className="col-6 col-sm-6 col-lg mb-3">
                <div className="footer-title" role="heading" aria-level="3">Coverage</div>
                <ul className="footer-link">
                  {/* <li>
                    <Link to="#" className="text-secondary">Country explorer</Link>
                  </li> */}
                  <li>
                    <Link to="/blog/" className="text-secondary">Press</Link>
                  </li>
                  <li>
                    <Link to="/contact-us/" className="text-secondary">Contact us</Link>
                  </li>
                </ul>
              </div>
              {/* <div className="col-6 col-sm-6 col-lg mb-3">
                <div className="footer-title">Contact</div>
                <Link to="#" className="text-secondary">info@omnidya.com</Link>
                <div>Tel: 657-234-3690</div>
                <div>Find us on Map</div>
              </div> */}
            </div>
          </div>
        </div>
        <div class="copyright">
          Omnidya.com. All rights reserved. 2020
        </div>
      </div>
    </div>
  )
}

export default Footer;
